import { render, staticRenderFns } from "./otherQuery.vue?vue&type=template&id=26533cf3&scoped=true"
import script from "./otherQuery.vue?vue&type=script&lang=js"
export * from "./otherQuery.vue?vue&type=script&lang=js"
import style0 from "./otherQuery.vue?vue&type=style&index=0&id=26533cf3&prod&lang=css"
import style1 from "./otherQuery.vue?vue&type=style&index=1&id=26533cf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26533cf3",
  null
  
)

export default component.exports